<template>
    <div class="xi">
        <hd-com></hd-com>
        <searchhdCom></searchhdCom>
           <div class="content-wrap">
            <div class="center-box">
                <div class="content clearfix" style="position: relative;">
                     <div class="center-center flex-start flex-wrap">
                        <div class="shopGoodBox">
                            <div class="shopGoodBoxTop">
                                <el-carousel height="350px"  style="width: 350px;">
                                    <el-carousel-item v-for="item in DetailData.coverImageUrls1" :key="item">
                                        <el-image
                                        style="width: 350px; height: 100%"
                                        :src="Services.ossUpload + item"
                                        :fit="fit">
                                    </el-image>
                                    </el-carousel-item>
                                </el-carousel>
                                <div class="shopGoodBoxRight">
                                    <span class="shopGoodBoxName">{{DetailData.name}}</span>
                                    <div class="shopGoodBoxSold">已销 {{DetailData.soldNum}}</div>
                                    <div class="shopGoodPrice"><span><span style="font-size: 14px;">￥</span>{{commodity.ordinaryPrice}}</span>
                                        <span  style="font-size: 16px;color: #999999;text-decoration-line: line-through;margin-left:20px">￥{{commodity.guidancePrice}}</span>
                                    </div>
                                    <div class="flex-l">
                                        <span>规格:</span>
                                        <div :class="indexCom == index ?  'tagcomCheck' : 'tagcom' " v-for="(item,index) in DetailData.commoditySpecifications" :key="index" @click="gonewDetai(item,index)">
                                            {{item.name}}
                                        </div>    
                                    </div>

                                    <div class="shopGoodBot">
                                        <el-input-number style="width:30%;margin-right:10px" v-model="numTotal" controls-position="right" @change="handleChange" :min="1" :max="stockNum"></el-input-number>
                                        <el-button type="primary" @click="gobug">立即购买</el-button>
                                        <!-- <el-button >加入购物车</el-button> -->
                                    </div>
                                    <div class="flex-l" style="margin-top:10px">
                                        <span>库存:</span> 
                                         {{commodity.stockNum}}
                                    </div>
                                </div>
                            </div>

                            <div style="margin-top:50px">
                                <div class="shopTab">
                                    <div class="shopTabBox">
                                        <div class="shopTabno">
                                            商品详情
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-top:25px">
                                    <div v-html="DetailData.instructions"></div>
                                    <div v-html="DetailData.introduce"></div>
                                    <div v-html="DetailData.customerService"></div>
                                </div>
                            </div>
                        </div>
                     </div>
                </div>
            </div>
           </div>
        <ft-com></ft-com>
        <rt-bar></rt-bar>
    </div>
</template>

<script>


import hdCom from '../../components/intshopheader'
import searchhdCom from '../../components/insearchHeader'

import ftCom from '../../components/footer'
// import rtBar from "../../components/right";
import { videoMain } from "../../components/video/video"
export default {
    name: "healthKnow",
    components: {
        hdCom,
        searchhdCom,
        ftCom,
        // rtBar
    },
    data() {
        var video = new videoMain(this.TokenClient, this.Services.shoppingMall)
        return {
            videoDomain: video,
            DetailData:{},
            commodity:{},
            numTotal:1,
            stockNum:0,
            indexCom:0
        }
    },
    methods: {
        gonewDetai(e,e1){
            console.log(e)
            var _this = this
            _this.stockNum = e.stockNum
            _this.commodity = e
            _this.indexCom = e1
        },
        gobug(){
            // 产品信息
            let params = []
            params.push(
            {
                goodName:this.DetailData.name,
                shopId:this.DetailData.merchantShopId,
                shopName:this.DetailData.shopName,
                coverImageUrls:this.commodity.coverImageUrls,
                commoditySpecificationsId:this.commodity.id,
                ordinaryPrice:this.commodity.ordinaryPrice,
                name:this.commodity.name,
                num:this.numTotal,
                // isSend:this.DetailData.isSend
            })
            this.$router.push({
                path: './shopBuy',
                query: {
                    commodity: JSON.stringify(params)
                }
            })
        },
        //详情获取
        Detail() {
            var _this = this;
            _this.videoDomain.getAppletDetail(this.$route.query.id, function (data) {
                _this.DetailData = data.data;
                var f = _this.DetailData.coverImageUrls.split(',') 
				_this.DetailData.coverImageUrls1 = f
                _this.commodity = data.data.commoditySpecifications[0]
                _this.stockNum = data.data.commoditySpecifications[0].stockNum
            },
            function (error) {

            })
        },
    },
    mounted() {
        this.Detail();
    },
    destroyed() {
        //销毁监听
    },
}
</script>
<style lang="scss" scoped>
.shopTab {
    border-bottom: 1px solid #E6E6E6;
}
.shopTabBox {
    display: flex;
    align-items: center;
}
.shopTabno {
    font-size: 15px;
    // color: #FFFFFF;
    font-weight: bold;
    padding: 10px 50px;
    cursor: pointer;
}
.shopTabChecked {
    font-size: 15px;
    padding: 10px 50px;
     cursor: pointer;
}
.tagcomCheck {
    padding: 5px 15px;
    border-radius: 2px;
    border: 1px solid #00AFB5;
    font-size: 14px;
    color: #00AFB5;
    margin-left: 10px;
    cursor: pointer;
}
.tagcom {
    padding: 5px 15px;
    background: #F0F0F0;
    border-radius: 2px;
    font-size: 14px;
    margin-left: 10px;
    color: #333333;
    cursor: pointer;
}

.banner {
    height: 116px;
    background: url("../../assets/img/jbk_banner.png")center no-repeat;
}
.shopGoodBox {
    width: 100%;
    background: #FFFFFF;
    border-radius: 40px;
    padding: 40px 50px;
}
.flex-l {
    display: flex;
    align-items: center;
}
.shopGoodBoxTop {
   display: flex;
}
.shopGoodBoxRight {
    margin-left: 60px;
}
.shopGoodBoxName {
    font-weight: bold;
    font-size: 20px;
    color: #1A1A1A;
}
.shopGoodPrice {
    font-size: 24px;
    color: #E1251B;
    margin-bottom: 30px;
}
.shopGoodBot {
    margin-top: 30px;
}
.shopGoodBoxSold {
    font-size: 16px;
    color: #CCCCCC;
}
.banner-text {
    width: 1200px;
    margin: 0 auto;

    h3 {
        padding-top: 25px;
        font-size: 26px;
        font-weight: normal;
        color: #ffffff;
    }

    p {
        font-size: 18px;
        color: #ffffff;

        a {
            color: #ffffff;
            font-size: 14px;
            margin: 0 5px;
        }
    }
}

.content-wrap {
    background: #F5F6F6;
}


.content {
    position: relative;
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;

}

.menu-box {
    width: 100%;
    background: #fff;
    height: auto;

    .box {
        align-items: flex-start !important;
        margin-bottom: 10px;
    }

    .menu-title {
        width: 90px;
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-content {
        width: calc(100% - 95px);
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #999999;
    }

    .menu-item {
        width: auto;
        margin: 0 5px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        height: 40px;
        padding: 0 10px;
    }

    .menu-item:hover {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
        cursor: pointer;
    }

    .menuActive {
        background: #F5F6F6;
        border-radius: 2px;
        color: #00998B;
    }
}



.healthKnow .el-radio {
    margin-right: 30px;
}

#page ::v-deep .el-pagination {
    text-align: center;
    margin: 30px auto;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    background-color: #fff;
}

#page ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #01C2AC;
}

#page ::v-deep .el-pagination.is-background .btn-next,
#page ::v-deep .el-pagination.is-background .btn-prev,
#page ::v-deep .el-pagination.is-background .el-pager li {
    border-radius: 2px;
}
</style>
